/**
 * Client-specific identity. The ONLY place any of this may live.
 *
 * Never hardcode a company name, logo or support link in a component, page,
 * service or test. One branding config per client deployment.
 *
 * The product name is deliberately unset -- see "Decisions Taken" in CLAUDE.md.
 * `name` carries a neutral descriptor until a brand is chosen; do not invent one.
 */
export const branding = {
  name: 'Regulatory Intelligence',
  subtitle: 'ANATEL · CADE · ANEEL · ANS · IBAMA · BACEN · CVM',
  supportUrl: '',
  defaultTheme: 'dark' as const,
  /** Brazilian regulatory lawyers are the users; the corpora are Portuguese. */
  defaultLocale: 'pt' as const,
  /**
   * Sibling platform: Lex Metrica, precatorio pricing. It is a SEPARATE
   * deployable with its own database and its own session, so it is reached by
   * LINK and never embedded -- it renders its own chrome, and its token lives
   * in localStorage, which a cross-origin iframe partitions.
   *
   * Blank this env var to hide the launcher entirely, rather than ship a button
   * pointing at nothing. The fallback below is the deployed site, which means a
   * LOCAL run with no override sends you to production -- copy .env.example to
   * frontend/.env.local to point it at the local dev server instead.
   */
  precatoriosPlatformUrl:
    import.meta.env.VITE_PRECATORIOS_PLATFORM_URL ?? 'https://www.lex-metrica.com',
} as const;

export type Branding = typeof branding;
